import React, { Fragment } from 'react';
import { inject } from 'mobx-react';
import Utils from './util.js';


const FormattedNumberCurrency = ({ number, currencyCode = 'EUR', languageStore }) => (
	<Fragment>
		{
			Utils.formatNumberCurrency(number, currencyCode, languageStore.ISOCode)
		}
	</Fragment>
);

export default inject('languageStore')(FormattedNumberCurrency);
